/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

export const FORMS = ['OCF', 'DCF', 'UCF', 'CSCF'];

export const FORM_FIELDS = {
  DCF: ['priority', 'patient', 'additional', 'site', 'subject', 'reason', 'change', 'upload'],
  OCF: ['priority', 'patient', 'additional', 'site', 'subject', 'reason', 'change', 'upload'],
  CSCF: ['priority', 'patient', 'additional', 'site', 'subject', 'reason', 'change', 'upload'],
  UCF: ['priority', 'userChangeType', 'userType', 'userRole', 'additional', 'reason', 'change', 'upload']
};
export const REQUIRED_FIELDS = {
  UCF: ['userChangeType', 'userType', 'userRole'],
  all: ['priority', 'patient', 'site', 'change']
};
export const UCF_DEPENDENT_REQUIRED_FIELDS = {
  userType: 'userChangeType',
  userRole: 'userChangeType'
};

export const RESPONSE_SUCCESS_FIELD = [
  'study',
  'requestor',
  'requestorLocation',
  'requestorStudyBlindingStatus',
  'ticketNumber',
  'form',
  'localDateTime',
  'serverDateTime',
  'approvalStatus'
];
export const SCREENS = {
  SAVE: 'save',
  RESPONSE: 'response'
};
export const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4 MB

export const DROPDOWN_OPTIONS = {
  prioFields: ['low', 'high'],
  patientFields: ['no', 'yes'],
  userChangeTypes: ['singleUser', 'multiUser'],
  userTypes: ['blinded', 'unblinded']
};

export const dcfformname = 'DCF';
export const ucfformname = 'UCF';
export const ocfformname = 'OCF';
export const cscfformname = 'CSCF';
